"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSelfMigrate = exports.CSS = void 0;
const tslib_1 = require("tslib");
const hyperscript_1 = tslib_1.__importDefault(require("mithril/hyperscript"));
const icon_1 = require("../../components/icon");
const icons_1 = require("../../components/icon/icons");
const mithril_component_1 = require("../../components/mithril.component");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const theme_palette_1 = require("../../components/theme.palette");
const index_1 = require("../../i18n/index");
const page_1 = require("../../page/page");
const services_1 = require("../../services");
const classnames_1 = require("../../util/classnames");
const auth_component_style_1 = require("./auth.component.style");
const migrate_user_ctrl_1 = require("./migrate.user.ctrl");
exports.CSS = {
    emailInput: 'c-MigrateUser__emailAddress',
    emailInputHasError: 'c-MigrateUser__emailAddress-has-error',
    validationError: 'c-MigrateUser__validationError',
    spinner: 'c-MigrateUser__spinner',
    formError: 'c-MigrateUser__formError',
    successIcon: 'c-MigrateUser__successIcon',
};
const Style = {
    [exports.CSS.emailInput]: {
        borderRadius: theme_1.DefaultTheme.space(1),
        flexBasis: '100%',
        padding: theme_1.DefaultTheme.space(3),
        border: `2px solid ${theme_palette_1.ColorPalette2022Branding.g9}`,
        boxSizing: 'border-box',
        width: '100%',
        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
    },
    [`${exports.CSS.emailInput}:focus, ${exports.CSS.emailInput}:focus-visible`]: {
        outline: 'none',
        borderColor: theme_palette_1.ColorPalette2022Branding.lightBlue,
    },
    [exports.CSS.emailInputHasError]: {
        borderColor: `${theme_palette_1.ColorPalette2022Branding.error} !important`,
        borderBottomRightRadius: '0 !important',
        borderBottomLeftRadius: '0 !important',
    },
    [exports.CSS.validationError]: {
        background: theme_palette_1.ColorPalette2022Branding.error,
        borderBottomRightRadius: theme_1.DefaultTheme.space(1),
        borderBottomLeftRadius: theme_1.DefaultTheme.space(1),
        color: 'white',
        padding: theme_1.DefaultTheme.space(1),
    },
    [`${exports.CSS.spinner} div`]: {
        border: `2px solid ${theme_palette_1.ColorPalette2022Branding.g7}`,
        borderTopColor: 'transparent',
    },
    [exports.CSS.formError]: {
        color: theme_palette_1.ColorPalette2022Branding.error,
        textAlign: 'left',
        marginTop: theme_1.DefaultTheme.space(2),
    },
    [exports.CSS.successIcon]: {
        color: theme_palette_1.ColorPalette2022Branding.success,
        fontSize: theme_1.DefaultTheme.space(8),
        marginBottom: theme_1.DefaultTheme.space(2),
    },
};
(0, theme_1.addStyles)(auth_component_style_1.Style);
(0, theme_1.addStyles)(Style);
class UserSelfMigrate extends mithril_component_1.IMithrilStateComponent {
    constructor() {
        super();
        this.ctrl = new migrate_user_ctrl_1.MigrateUserController();
        // We still keep the reactions on the state component (instead of the controller) BECAUSE
        // the onRemove hook runs the disposers for any reactions we declare.
        this.reaction(() => this.ctrl.value, () => {
            this.ctrl.isDirty = true;
            this.ctrl.isValid = migrate_user_ctrl_1.MigrateUserController.validateEmail(this.ctrl.value);
        });
    }
    get validationError() {
        if (!this.ctrl.isDirty || this.ctrl.isValid) {
            return null;
        }
        return (0, hyperscript_1.default)('div', {
            className: exports.CSS.validationError,
        }, (0, index_1.Translate)(index_1.T.ENTER_VALID_EMAIL));
    }
    get error() {
        if (this.ctrl.formError) {
            return (0, hyperscript_1.default)('div', {
                className: exports.CSS.formError,
            }, this.ctrl.formError);
        }
        return null;
    }
    get nodes() {
        return (0, hyperscript_1.default)('form', { className: auth_component_style_1.CSS.container }, [
            (0, hyperscript_1.default)('div', {
                className: auth_component_style_1.CSS.text,
            }, (0, hyperscript_1.default)('div', {
                className: auth_component_style_1.CSS.textInner,
            }, (0, index_1.Translate)(index_1.T.SSO_UPGRADE_ACCOUNT))),
            this.ctrl.hasSubmitted
                ? [
                    icon_1.Icon.view(icons_1.MaterialIcon.CHECK_CIRCLE, {
                        className: exports.CSS.successIcon,
                    }),
                    (0, index_1.Translate)(this.ctrl.isNewUser ? index_1.T.SSO_MIGRATE_EMAIL_SENT : index_1.T.SSO_MIGRATE_EMAIL_EXISTING),
                ]
                : [
                    (0, hyperscript_1.default)('input', {
                        className: (0, classnames_1.classNames)(exports.CSS.emailInput, {
                            [exports.CSS.emailInputHasError]: this.ctrl.hasError,
                        }),
                        placeholder: 'user@ikegps.com',
                        onkeyup: (event) => {
                            this.ctrl.value = event.target.value;
                        },
                        value: this.ctrl.value,
                        disabled: this.ctrl.inFlight,
                    }),
                    this.validationError,
                    this.error,
                    (0, hyperscript_1.default)('div', {
                        className: auth_component_style_1.CSS.padding,
                    }, (0, hyperscript_1.default)('button', {
                        className: (0, classnames_1.classNames)('mdl-button', 'mdl-button--raised', auth_component_style_1.CSS.button),
                        onclick: (event) => {
                            event.preventDefault();
                            // eslint-disable-next-line @typescript-eslint/no-floating-promises
                            this.ctrl.submit();
                        },
                        disabled: !this.ctrl.isDirty || this.ctrl.hasError || this.ctrl.inFlight,
                    }, this.ctrl.inFlight ? spinner_1.Spinner.view(exports.CSS.spinner) : (0, index_1.Translate)(index_1.T.SUBMIT))),
                ],
            (0, hyperscript_1.default)('div', {
                className: auth_component_style_1.CSS.padding,
            }, (0, hyperscript_1.default)('a', {
                className: auth_component_style_1.CSS.link,
                onclick: () => services_1.Services.Route.go(page_1.IkePageName.login),
            }, (0, index_1.Translate)(index_1.T.BACK_TO_LOGIN))),
        ]);
    }
}
exports.UserSelfMigrate = UserSelfMigrate;
//# sourceMappingURL=migrate.user.js.map